// --- Message role ---
export var MessageRole;
(function (MessageRole) {
    MessageRole["SYSTEM"] = "system";
    MessageRole["USER"] = "user";
    MessageRole["ASSISTANT"] = "assistant";
    MessageRole["TOOL"] = "tool";
    MessageRole["SUMMARY"] = "summary";
    MessageRole["DEBUG"] = "debug";
    MessageRole["INFO"] = "info";
    MessageRole["ERROR"] = "error";
})(MessageRole || (MessageRole = {}));
